<template>
  <!--<div class="home">-->
    <!--<img src="../assets/logo.png">-->
    <!--<HelloWorld msg="Welcome to Your Vue.js App"/>-->
  <!--</div>-->
   <div class="wrap clearfix">
        <!-- 모바일 메뉴 -->
        <div  v-if="this.is_mobile() &&  this.account.is_admin" class="home-card-menu">
          <mobile-menu :pharm_id="account.pharm_id"></mobile-menu>
        </div>
        <!-- 프로필 관리 -->
        <div class="home-card card1">
          <profile :pharm_id="account.pharm_id"></profile>
        </div>
        <div v-if="this.is_mobile()" class="home-card card6">
          <pharm-home :pharm_id="account.pharm_id"></pharm-home>
        </div>
        <div v-if="!this.is_mobile()" class="home-card card4">
          <pharm-home :pharm_id="account.pharm_id"></pharm-home>
        </div>       
    </div>
</template>

<script>
import { nameByConstMixin } from '@/lib/mixins'
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import { mapState, mapActions } from 'vuex'
import Profile from '@/components/Home/Profile.vue'
import PharmHome from '@/components/Home/PharmHome.vue'
import MobileMenu from '@/components/Home/MobileMenu.vue'


export default {
  mixins: [ nameByConstMixin ],
  name: 'home',
  data() {
      return {
        parent_data: 1
      }
    },
  computed: {
    ...mapState(['account']),
  },
  methods: {
      async onChangeView (view_type) {
        this.parent_data = view_type;
      }
  },
  components: {
     Profile, PharmHome, MobileMenu
  },
  
}
</script>

<style scoped>
    /* Contents
------------------------------------------------------- */

/* Main */
.wrap {
    width: 100%;
    max-width: 1240px;
    margin: 55px auto;
}

.home-card-menu {
    float: left;
    width: 100%;
    min-height: 30px;
    margin-top: 20px;
    margin-bottom: -20px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 2px 2px 5px rgba(50, 50, 50, .1);
}

.home-card {
    float: left;
    width: 550px;
    min-height: 370px;
    /* margin-top: 20px; */
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    box-shadow: 2px 2px 5px rgba(50, 50, 50, .1);
}

.home-card:nth-of-type(even) {
    margin-right: 0;
}

@media screen and (max-width: 1460px) {
    .wrap {
        max-width: 630px;
    }
}
</style>
